import React, { useState, useEffect } from "react";
import { Modal, Input, Form, Row, Col, Typography, Select, message } from "antd";
import { platformApi } from "../../../../api";

const { Item } = Form;
const { Text, Title } = Typography;
const { Option } = Select;

const BinLocationForm = (props) => {
  const [loading, setLoading] = useState(false);
  const [editable, setEditable] = useState(props.editable);
  const [branches, setBranches] = useState([]);

  const { form, open, close, data, modify, emitData } = props;
  const { getFieldDecorator, setFieldsValue, resetFields, validateFields } = form;

  useEffect(() => {
    setEditable(props.editable);
    if (data) {
      setFieldsValue({
        branch: data.branch || (data.Branch ? data.Branch.id : undefined),
        binLocation: data.binLocation,
      });
    }
  }, [data, props.editable]);

  useEffect(() => {
    if (open) {
      fetchBranches();
    }
  }, [open]);

  const fetchBranches = () => {
    platformApi
      .get("/api/company/branches")
      .then((result) => {
        const { data } = result;
        if (data.code === 200) {
          const { response } = data;
          if (response && response.code === 200) {
            setBranches(response.data || []);
          }
        }
      })
      .catch((error) => {
        console.error("Error fetching branches for Bin Location: ", error);
        message.error("Unable to fetch branches");
      });
  };

  const handleSubmit = () => {
    validateFields((err, values) => {
      if (!err) {
        setLoading(true);
        const payload = {
          branch: values.branch,
          binLocation: values.binLocation.trim(),
        };
        if (data && data.id) {
          payload.id = data.id;
        }
        emitData(payload);
        setLoading(false);
        resetFields();
        close();
      }
    });
  };

  return (
    <Modal
      title={<Title level={4}>{data && data.id ? "Edit Bin Location" : "Add Bin Location"}</Title>}
      visible={open}
      okText={editable ? "Save" : "Modify"}
      onCancel={() => {
        resetFields();
        close();
      }}
      okButtonProps={{ loading, disabled: !modify && !editable }}
      onOk={() => (editable ? handleSubmit() : setEditable(true))}
    >
      <Form layout="vertical">
        <Row type="flex" justify="space-between">
          <Col span={24}>
            <Item label={<Text strong>Branch</Text>} colon={false} required>
              {getFieldDecorator("branch", {
                rules: [{ required: true, message: "Please select branch!" }],
              })(
                <Select
                  disabled={!editable}
                  placeholder="Select Branch"
                  showSearch
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                  }
                >
                  {branches.map((b) => (
                    <Option key={b.id} value={b.id}>
                      {b.name}
                    </Option>
                  ))}
                </Select>
              )}
            </Item>
          </Col>
        </Row>
        <Row type="flex" justify="space-between">
          <Col span={24}>
            <Item label={<Text strong>Bin Location</Text>} colon={false} required>
              {getFieldDecorator("binLocation", {
                rules: [{ required: true, message: "Please enter Bin Location!" }],
              })(
                <Input
                  disabled={!editable}
                  placeholder="Enter Bin Location"
                  maxLength={100}
                />
              )}
            </Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
};

const WrappedBinLocationModal = Form.create({ name: "bin_location_form" })(BinLocationForm);

export default WrappedBinLocationModal;
